import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import type { RootState } from '../store'
import { identifyFullStoryUser } from '../lib/fullstory'

/** Sync the authenticated user to FullStory and the captured session's identity artifact. */
export default function FullStoryAuthBridge() {
  const user = useSelector((state: RootState) => state.auth.user)

  useEffect(() => {
    identifyFullStoryUser(user)
  }, [user])

  return null
}
